module.exports = __webpack_public_path__ + "img/15a-doc-implantar-form.afa799b2.png";